import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { ButtonType, ButtonWidget, HorizontalOriginOption,TabStyles, VerticalOriginOption } from '@tableau/widgets';
import React from 'react';
import { useRef } from 'react';

import { usePrevious } from '~src/bootstrap/hooks';
import { Messages } from '~src/codegen/Localize';
import { ButtonWithUberDialog } from '~src/commonInfra/components/ButtonWithUberDialog';

import { FlowSubscriptionDialogContent, FlowSubscriptionDialogContentProps } from './FlowSubscriptionDialogContent';

export type FlowSubscriptionButtonWithDialogProps = FlowSubscriptionDialogContentProps & {
  readonly shouldSendEmailWhenDone: boolean;
  readonly onDialogClose: () => void;
}

export const FlowSubscriptionButtonWithDialog: React.FC<FlowSubscriptionButtonWithDialogProps>  = (props: FlowSubscriptionButtonWithDialogProps) => {
  const buttonRef = useRef<HTMLButtonElement>();
  const previousShouldSendEmailWhenDone: boolean = usePrevious(props.shouldSendEmailWhenDone);
  React.useLayoutEffect(
    // when 'send email when done' checkbox is checked, open the uber dialog
    () => {
      if (previousShouldSendEmailWhenDone === false && props.shouldSendEmailWhenDone === true) {
       buttonRef.current?.click();
      }
    },[previousShouldSendEmailWhenDone, props.shouldSendEmailWhenDone]
  );
  return (
    <ButtonWithUberDialog
      renderButton={showDialog => (
        <ButtonWidget
          testId={'flow-subscription-edit-button'}
          buttonType={ButtonType.Icon}
          title={Messages.flowSubscriptionsEditButton()}
          onClick={showDialog}
          disabled={!props.shouldSendEmailWhenDone}
          style={{
            padding: `${TabStyles.Spacing.SmallSpace}px`,
            marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
          }}
          buttonRef={buttonRef}
        >
          <PencilBaseIcon
            alt={''}
            size={18}
          />
        </ButtonWidget>
      )}
      dialogWidth={500}
      anchorOrigin={{
        vertical: VerticalOriginOption.top,
        horizontal: HorizontalOriginOption.right
      }}
      uberDialogContent={
        <FlowSubscriptionDialogContent
          outputs={props.outputs}
          shouldSendToMe={props.shouldSendToMe}
          subjectValue={props.subjectValue}
          messageValue={props.messageValue}
          shouldIncludeOutputData={props.shouldIncludeOutputData}
          selectedOutputForSubscription={props.selectedOutputForSubscription}
          shouldAttachOutputDataToEmail={props.shouldAttachOutputDataToEmail}
          shouldShowFirstNRows={props.shouldShowFirstNRows}
          outputFileFormat={props.outputFileFormat}
          shouldIncludeLinkToDatasource={props.shouldIncludeLinkToDatasource}
          onShouldSendToMeToggled={props.onShouldSendToMeToggled}
          onShouldIncludeOutputDataToggled={props.onShouldIncludeOutputDataToggled}
          onAttachOutputDataToEmailToggled={props.onAttachOutputDataToEmailToggled}
          onShowFirstNRowsToggled={props.onShowFirstNRowsToggled}
          onIncludeLinkToDatasourceToggled={props.onIncludeLinkToDatasourceToggled}
          onSubjectChange={props.onSubjectChange}
          onMessageChange={props.onMessageChange}
          emailRecipients={props.emailRecipients}
          onRecipientsChange={props.onRecipientsChange}
          onOutputFileFormatChange={props.onOutputFileFormatChange}
          onSelectedOutputForSubscriptionChange={props.onSelectedOutputForSubscriptionChange}
        />
      }
      onDialogClose={props.onDialogClose}
    />
  );
};

FlowSubscriptionButtonWithDialog.displayName = 'FlowSubscriptionButtonWithDialog';
